import { UserContacts } from '../types/dto';

export const parseUserContact: (contact: UserContacts | Record<string, never> | null) => UserContacts | null = (contact) => {
  if(contact && !Object.keys(contact).length) {
    return null;
  }

  return contact as UserContacts;
};
